import Vue from "vue";
import VueRouter from "vue-router";
import LoginView from "../views/LoginView.vue";
import Dashboard from "../views/DashboardView.vue";
import Turnos from "../views/AsignaTurnosView.vue";
import Inscripciones from "../views/InscripcionesView.vue";
import Inscribir from "../views/InscribirView.vue";
import Procesiones from "../views/ProcesionesView.vue";
import Tracking from "../views/TrackingView.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "login",
    component: LoginView
  },
  {
    path: "/dashboard",
    name: "Dashboard",
    component: Dashboard
  },
  {
    path: "/turnos",
    name: "Turnos",
    component: Turnos
  },
  {
    path: "/inscripciones",
    name: "Inscripciones",
    component: Inscripciones
  },
  {
    path: "/inscribir",
    name: "Inscribir",
    component: Inscribir
  },
  {
    path: "/procesiones",
    name: "Procesiones",
    component: Procesiones
  },
  {
    path: "/tracking/:processionId",
    name: "Tracking",
    component: Tracking,
    props: true
  }
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes
});

export default router;
